import React, { CSSProperties, FocusEvent, MouseEvent, ReactNode } from "react";

import cn from "classnames";

import styles from "./MenuOption.module.scss";

interface Props {
  children?: ReactNode;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  onFocus?: (event: FocusEvent<HTMLDivElement>) => void;
  onMouseEnter?: (event: MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (event: MouseEvent<HTMLDivElement>) => void;
  selected?: boolean;
  style?: CSSProperties;
}

const MenuOption: React.FC<Props> = ({
  children,
  onClick,
  onFocus,
  onMouseEnter,
  onMouseLeave,
  selected,
  style,
}) => {
  return (
    <div
      className={cn(styles.container, { [styles.selected]: selected })}
      onClick={onClick}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
    >
      {children}
    </div>
  );
};

export default MenuOption;
